/** How long toast notifications stay visible before auto-dismissing (ms). */
export const NOTIFICATION_AUTO_CLOSE_MS = 10_000;
